import * as XLSX from 'xlsx'
import React, { useState, useEffect } from "react";
import Table from "components/Table";
import {
  Spinner,
  Container,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Sort, Bell, Import, Download, Cloud, Plus } from "assets";
import { FormInputs, FormSelects } from "components/FormInputSelect";
import { TOOLBAR_SELECT_STYLES } from "components/toolbarSelectStyles";
import { BiFilter } from "react-icons/bi";
import { FaChevronRight, FaTrashAlt, FaUserCheck } from "react-icons/fa";
import "./pencipta.scss";
import CustomButton from "components/CustomButton";
import AddAnggota from "./AddAnggota";
import Pagination from "components/Pagination";
import ModalImport from "components/ModalImport";
import {
  API_GET_MAMBOO,
  BASE_URL,
  API_POST_MAMBOO,
  API_PUT_MAMBOO,
  API_DELETE_MAMBOO,
} from "services";
import StatusBadge from "components/StatusBadge";
import Swal from "sweetalert2";
import TableLoading from "components/TableLoading";
import useLoginStore from "hooks/useLoginStore";
import { useNavigate } from "react-router-dom";
import { columnLayout, actionColumnLayout } from "components/tableColumnLayout";

// Warna status mengikuti warna konfirmasi Swal yang sudah dipakai di aplikasi.
const MEMBER_COLOR = "#4dbd74";
const NON_MEMBER_COLOR = "#f63c3a";

// Sel kosong (mis. IP Base anggota Non-Member) diberi tanda pisah supaya
// terbaca sebagai "belum ada", bukan seperti data yang gagal dimuat.
const emptyDash = (cell) => {
  const value = typeof cell === "string" ? cell.trim() : cell;
  return value === "" || value === null || value === undefined ? "-" : cell;
};

// Menyalin tampilan .custom-button.btn-sm, tanpa perilaku tombol.
const STATUS_LABEL_STYLE = {
  display: "inline-flex",
  flex: "0 0 auto",
  alignSelf: "auto",
  width: "fit-content",
  padding: "8px 24px",
  borderRadius: "8px",
  color: "#FFF",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "-0.084px",
};

const Pencipta = () => {
  const [isShow, setIsShow] = useState({
    label: "5",
    value: 5,
  });
  const [addPencipta, setAddPencipta] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [isPage, setIsPage] = useState(1);
  const [isTotalPage, setIsTotalPage] = useState();
  const [detailPencipta, setDetailPencipta] = useState({});
  const [fileValue, setFileValue] = useState("");
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [previewData, setPreviewData] = useState({ headers: [], rows: [] });
  const [modalFilter, setModalFilter] = useState(false);
  const [open, setOpen] = useState('');
  const [isChecked, setIsChecked] = useState(true);
  const [isKeyword, setIsKeyword] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [activatingId, setActivatingId] = useState(null);
  const { profile, isVerified } = useLoginStore();
  const navigate = useNavigate();

  // Anggota dianggap Member begitu backend menerbitkan mamboo_id untuknya.
  const isMember = (row) => Boolean(row?.mamboo_id);

  /**
   * Payload aktivasi untuk PUT /api/user/creator-update/:id_user.
   *
   * `is_activation` adalah penanda alur, bukan kolom tabel: backend memakainya
   * untuk membedakan aktivasi dari edit anggota biasa, lalu menerbitkan
   * mamboo_id. Endpoint ini partial update, jadi field lain tidak perlu ikut.
   */
  const buildAktivasiPayload = () => {
    const data = new FormData();
    data.append("payload", JSON.stringify({ is_activation: true }));
    return data;
  };

  const handleAktivasi = (row) => {
    Swal.fire({
      icon: "question",
      title: "Aktivasi Anggota",
      text: `Aktifkan ${row.name} menjadi Member?`,
      showCancelButton: true,
      cancelButtonText: "Tidak",
      showConfirmButton: true,
      confirmButtonText: "Ya",
      confirmButtonColor: "#4dbd74",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      setActivatingId(row.creator_id);
      try {
        await API_PUT_MAMBOO.update.updatePenciptaByIdUser(
          row.creator_id,
          buildAktivasiPayload()
        );
        Swal.fire("Anggota berhasil diaktivasi", "", "success");
        fetchData();
      } catch (err) {
        const message =
          err?.response?.data?.data || "Aktivasi gagal. Silakan coba lagi.";
        Swal.fire("Gagal", message, "error");
      } finally {
        setActivatingId(null);
      }
    });
  };

  const formatButton = (cell, row, enumData, index) => {
    const isActivating = activatingId === row.creator_id;

    return (
      <>
        <FaChevronRight
          style={{ cursor: "pointer", padding: "0px 3px" }}
          onClick={() => {
            if (row.role === "Pencipta Lagu") {
              API_GET_MAMBOO.dynamic
                .getPenciptaByUserId(row.creator_id)
                .then((response) => {
                  handleOnClick("editAnggota", response);
                });
            } else {
              API_GET_MAMBOO.dynamic
                .getAhliWarisByIdUser(row.creator_id)
                .then((response) => {
                  handleOnClick("editAnggota", response);
                });
            }
          }}
        />
        {/* Aktivasi hanya relevan untuk anggota yang belum jadi Member. */}
        {!readOnly && !isMember(row) && (
          <FaUserCheck
            title="Aktivasi"
            // viewBox FaUserCheck lebih lebar (640x512) daripada FaTrashAlt
            // (448x512), jadi pada ukuran 1em tingginya cuma 0.8em. Diperbesar
            // 640/512 agar tingginya sama dengan ikon hapus.
            size="1.25em"
            style={{
              cursor: isActivating ? "wait" : "pointer",
              padding: "0px 3px",
              opacity: isActivating ? 0.5 : 1,
            }}
            onClick={() => {
              if (!isActivating) handleAktivasi(row);
            }}
          />
        )}
        {readOnly ? null : (
          <FaTrashAlt
            style={{ cursor: "pointer" }}
            onClick={() => {
              Swal.fire({
                title: `Hapus data ${row.role}`,
                text: `Data ${row.name} akan di hapus, apakah anda yakin ?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Hapus",
                confirmButtonColor: "#f63c3a",
                cancelButtonText: "Batal",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await API_DELETE_MAMBOO.dynamic
                    .deletePencipta(row.creator_id)
                    .then((resp) => {
                      Swal.fire("Data berhasil hapus", "", "success").then(
                        (result) => {
                          if (result.isConfirmed) {
                            fetchData();
                          }
                        }
                      );
                    });
                } else {
                  Swal.fire("Data batal dihapus", "", "info");
                }
              });
            }}
          />
        )}
      </>
    );
  };

  // Label status dibuat menyerupai tombol (padding & radius yang sama dengan
  // .btn-sm), tapi hanya penanda — tidak bisa diklik.
  const statusFormatter = (cell, row) => (
    <StatusBadge
      title={isMember(row) ? "Member" : "Non-Member"}
      customStyle={{
        ...STATUS_LABEL_STYLE,
        background: isMember(row) ? MEMBER_COLOR : NON_MEMBER_COLOR,
      }}
    />
  );

  const columnRefs = [
    {
      dataField: "name",
      text: (
        <>
          <span>Nama</span>
          <Sort />
        </>
      ),
      sort: true,
      headerStyle: columnLayout(1.6),
      style: columnLayout(1.6),
      formatter: emptyDash,
    },
    {
      dataField: "ip_base_number",
      text: (
        <>
          <span>IP Base</span>
        </>
      ),
      headerStyle: columnLayout(1, "center"),
      style: columnLayout(1, "center"),
      formatter: emptyDash,
    },
    {
      dataField: "email",
      text: "Email",
      // Kolom terlebar: isinya paling panjang dan paling sering terpotong.
      headerStyle: columnLayout(2.2),
      style: columnLayout(2.2),
      formatter: emptyDash,
    },
    {
      dataField: "role",
      text: (
        <>
          <span>Sebagai</span>
          <Sort />
        </>
      ),
      sort: true,
      headerStyle: columnLayout(1.2),
      style: columnLayout(1.2),
      formatter: emptyDash,
    },
    {
      dataField: "mamboo_id",
      text: "Status",
      formatter: statusFormatter,
      // Cukup untuk menampung badge "Non-Member" (teks + padding 24px kiri-kanan)
      // dalam satu baris; di bawah ini badge-nya mulai terpotong.
      headerStyle: columnLayout(1.5, "center"),
      style: columnLayout(1.5, "center"),
    },
    {
      dataField: "detail",
      text: "Detail",
      formatter: formatButton,
      headerStyle: actionColumnLayout(),
      style: actionColumnLayout(),
    },
  ];

  const options = [
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
  ];

    const onChangeSelect = (e) => {
    setIsShow({
      value: e.value,
      label: e.label,
    });
  };

  const handleOnClick = async (e, value) => {
    if (e === "editAnggota") {
      setDetailPencipta(value);
      await setAddPencipta(e);
    } else {
      await setAddPencipta(e);
    }
  };

  const handleClickNumber = (page) => {
    // Status dan keyword harus ikut dikirim; tanpa keduanya backend memakai
    // default "active" tanpa pencarian, jadi pindah halaman mereset filter.
    API_GET_MAMBOO.dynamic
      .getListPencipta(page, isShow.value, isChecked ? "active" : "inactive", isKeyword)
      .then((resp) => {
      let totalPage = Math.ceil(resp.total / isShow.value);
      setDataTable(resp.data);
      setIsTotalPage(totalPage);
      setIsPage(page);
    });
  };

  const toggle = () => {
    setModal(!modal);
    setFileValue("");
    setPreviewData({ headers: [], rows: [] });
  };

  const toggleFilter = () => {
    setModalFilter(!modalFilter);
  };

  const onChangeFile = (e) => {
    const { files } = e.target;
    if (files[0]) {
      const file = files[0];
      const fileUrl = URL.createObjectURL(file);
      setFileValue({ name: file.name, data: fileUrl, files: file });

      const reader = new FileReader();
      reader.onload = (evt) => {
        const wb = XLSX.read(new Uint8Array(evt.target.result), { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (jsonData.length > 0) {
          setPreviewData({ headers: jsonData[0], rows: jsonData.slice(1, 6) });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const data = {
        target: {
          files: e.dataTransfer.files,
        },
      };
      onChangeFile(data);
    }
  };

  const downloadTemplate = async () => {
    await setTimeout(() => {
      const response = {
        file: `${BASE_URL}/template/template_anggota.xlsx`,
      };
      window.open(response.file);
    }, 100);
  };

  const handleOnClickExcel = async () => {
    setIsLoading(true);
    const formData = new FormData();

    if (fileValue.files) {
      formData.append("excel_file", fileValue.files);
      await API_POST_MAMBOO.actions
        .postBulkPenciptaExcel(formData)
        .then((response) => {
          setIsLoading(false);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data berhasil di upload",
            showConfirmButton: false,
            timer: 1500,
          });
          setFileValue("");
          setModal(!modal);
          window.location.reload();
        })
        .catch(() => {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Data gagal di upload",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    }
  };

  const modalContent = () => {
    if (previewData.headers.length > 0) {
      return (
        <div className="custom-modal-body">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ background: 'var(--brand)', color: 'var(--brand-contrast)', borderRadius: '50%', width: '22px', height: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>2</span>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Preview Data</span>
            </div>
            <button
              onClick={() => { setPreviewData({ headers: [], rows: [] }); setFileValue(''); }}
              style={{ fontSize: '12px', color: 'var(--brand)', background: 'none', border: '1px solid var(--brand)', borderRadius: '4px', padding: '2px 10px', cursor: 'pointer' }}
            >
              Ganti File
            </button>
          </div>
          <span style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'block', marginBottom: '10px' }}>
            File: <strong>{fileValue.name}</strong>
          </span>
          <div style={{ overflowX: 'auto', border: '1px solid var(--border)', borderRadius: '6px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
              <thead>
                <tr style={{ background: 'var(--brand)' }}>
                  {previewData.headers.map((h, i) => (
                    <th key={i} style={{ padding: '8px 12px', color: 'var(--brand-contrast)', textAlign: 'left', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {previewData.rows.map((row, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : 'var(--surface-2)' }}>
                    {previewData.headers.map((_, j) => (
                      <td key={j} style={{ padding: '7px 12px', borderTop: '1px solid var(--border)', whiteSpace: 'nowrap' }}>{row[j] ?? ''}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <span style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '6px', display: 'block' }}>
            Menampilkan {previewData.rows.length} baris pertama
          </span>
        </div>
      );
    }

    return (
      <div className="custom-modal-body">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <span style={{ background: 'var(--brand)', color: 'var(--brand-contrast)', borderRadius: '50%', width: '22px', height: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' }}>1</span>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>Upload File</span>
        </div>
        <div className="download-template" onClick={downloadTemplate}>
          <span>Download Template Pencipta/Ahli Waris</span>
          <Download stroke="#3267E3" />
        </div>
        <div
          className="upload-container"
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <div className="upload-content">
            <Cloud />
            <span className="file-name" style={{ color: 'var(--text-primary)', fontSize: '16px' }}>
              {fileValue.name || "Upload Pencipta/Ahli Waris dari komputer atau drop file langsung disini"}
            </span>
            <div>
              <input
                onChange={onChangeFile}
                id="upload-file-pencipta"
                className="custom-file-input"
                type="file"
                accept=".xlsx,.xls"
              />
              <label htmlFor="upload-file-pencipta" className="custom-file-upload">
                <Plus stroke="#FFFFFF" />
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const modalContentVerified = () => {
    return (
      <div className="custom-modal-body">
        <span style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>Segera Verifikasi Publisher</span>
        <span style={{fontSize: 'small', fontSize: '15px'}}>Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu.</span>
      </div>
    )
  }

  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const modalContentFilter = () => {
    return (
    <div>
      <Accordion flush open={open} toggle={toggleAccordion}>
      <AccordionItem>
          <AccordionHeader targetId="1">Status Anggota</AccordionHeader>
          <AccordionBody accordionId="1">
          <FormGroup switch>
            <Input
              type="switch"
              checked={isChecked}
              onClick={() => {
                setIsChecked(!isChecked);
              }}
            />
            <Label check>{isChecked ? "Aktif" : "Non Aktif"}</Label>
          </FormGroup>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
    )
  };

  const fetchData = () => {
    setIsLoading(true)
    if(isChecked) {
      API_GET_MAMBOO.dynamic
        .getListPencipta(isPage, isShow.value, "active", isKeyword)
        .then((resp) => {
          let totalPage = Math.ceil(resp.total / isShow.value);
          setDataTable(resp.data);
          setIsTotalPage(totalPage);
          setIsLoading(false)
        });
    } else {
      API_GET_MAMBOO.dynamic
        .getListPencipta(isPage, isShow.value, "inactive", isKeyword)
        .then((resp) => {
          let totalPage = Math.ceil(resp.total / isShow.value);
          setDataTable(resp.data);
          setIsTotalPage(totalPage);
          setIsLoading(false)
        });
    }
  };

  useEffect(() => {
    fetchData();

    if(profile.access && profile?.access?.length > 0) {
      profile.access.filter((val) => {
        if(val.access_name === "Kelola Anggota") {
          setReadOnly(val.is_read_only)
        } else if (val.access_name === "Super Admin") {
          setReadOnly(val.is_read_only)
        }
      })
    }

  }, [isShow, isChecked, isKeyword]);

  return (
    <>
      {addPencipta === "tambahAnggota" || addPencipta === "editAnggota" ? (
        <AddAnggota
          handleBack={(e) => handleOnClick("", setDetailPencipta({}))}
          detailPencipta={detailPencipta}
          isEdit={addPencipta === "editAnggota" && true}
          isReadOnly={readOnly}
        />
      ) : (
        <Container fluid className="content-pencipta">
          <div className="header-content">
            <div className="pencipta-header">
              <h1>Songwriter</h1>
            </div>
            <div className="icon-wrapper">
              <Bell />
            </div>
          </div>
          <div className="tabs-filters">
            <div className="frame-filters">
              <div className="frame-sub-filters">
                <div className="frame-cari-nama">
                  <div className="box-text-cari-nama">
                    <span className="text-cari-nama">Cari Nama</span>
                  </div>
                  <FormInputs
                    placeholder="Masukkan Nama"
                    className="frame-cari-nama"
                    onChange={(e) => {
                      setIsKeyword(e.target.value);
                    }}
                    value={isKeyword}
                  />
                </div>
              </div>
              <CustomButton
                label="Filter"
                LabelIcon={BiFilter}
                onClick={toggleFilter}
                iconPosition="left"
                size="md"
                className="button-filter"
              />
              {readOnly ? null : (
                <>
                  <CustomButton
                    label="Import"
                    LabelIcon={Import}
                    onClick={toggle}
                    iconPosition="left"
                    size="md"
                    className="button-import"
                  />
                  <CustomButton
                    label="Tambah Anggota"
                    color="primary-btn"
                    size="md"
                    className="button-add-anggota"
                    onClick={(e) => handleOnClick("tambahAnggota")}
                  />
                </>
              )}
            </div>
          </div>
          {isLoading ? (
            <div className="">
              {/* <Spinner size="lg" color="light" /> */}
              <TableLoading columnRefs={columnRefs} isShow={isShow.value} />
            </div>
          ) : (
            <Table
              columnRefs={columnRefs}
              dataTable={dataTable}
              noDataText="Tidak Ada Data Songwriter"
            />
          )}
          {/* Satu baris kaki tabel: pemilih jumlah baris di kiri, lalu
              keterangan halaman dan navigasinya. Ketiganya mengatur paginasi,
              jadi dikumpulkan dalam satu baris. Garis atas dan padding kiri
              dipindah ke pembungkus ini (lihat .table-footer di pencipta.scss)
              supaya garisnya membentang penuh, bukan mulai setelah "Show". */}
          <div className="table-footer">
            <div className="table-footer-filters">
              <p className="text-show">Show :</p>
              <FormSelects
                options={options}
                onChange={onChangeSelect}
                defaultValue={isShow}
                value={isShow}
                styles={TOOLBAR_SELECT_STYLES}
              />
            </div>
            <Pagination
              isTotalPage={isTotalPage}
              isPage={isPage}
              handleClickNumber={handleClickNumber}
              pageToShow={6}
            />
          </div>
        </Container>
      )}
      <ModalImport
        modal={modal}
        toggle={toggle}
        title="Upload Pencipta/Ahli Waris"
        body={modalContent()}
        buttonLabel={
          isLoading ? (
            <>
              <Spinner size="sm" color="light" />
              &nbsp;&nbsp;Upload File
            </>
          ) : (
            "Upload File"
          )
        }
        onClick={handleOnClickExcel}
      />
      <ModalImport
        modal={modalFilter}
        toggle={toggleFilter}
        title="Filter"
        body={modalContentFilter()}
        centered={true}
        buttonLabel={"Tutup"}
        onClick={() => setModalFilter(!modalFilter)}
        color="danger"
      />
      <ModalImport
        modal={!isVerified}
        title=""
        body={modalContentVerified()}
        centered={true}
        buttonLabel={"Go to Profile"}
        onClick={() => navigate("/profile")}
      />
    </>
  );
};

export default Pencipta;
